import { eventsAuthenticatedAxios } from '@/api/axios'
import type { Contact, Identity, ItemReference } from '@/types'

export type ElevatedRole = 'Support' | 'Admin' | 'SuperAdmin'

export interface AdminUserSearchItem {
    id: string
    email: string
    name?: string
    roles: string[]
    organizerCount: number
}

export interface AdminUserSummary {
    id: string
    email: string
    name?: string
    roles: string[]
    lastLoginTime?: string
    organizerCount: number
    organizerFor: ItemReference[]
    contact?: Contact
    identity?: Identity
}

export interface AdminUserSearchResponse {
    query: string
    skip: number
    take: number
    total: number
    items: AdminUserSearchItem[]
}

export interface AdminUserRoleMutationResponse {
    correlationId: string
    user: AdminUserSummary
}

export async function searchAdminUsers(q: string, skip = 0, take = 20) {
    const { data } = await eventsAuthenticatedAxios.get<AdminUserSearchResponse>('admin/users/search', {
        params: {
            q,
            skip,
            take
        }
    })

    return data
}

export async function getAdminUserSummary(id: string) {
    const { data } = await eventsAuthenticatedAxios.get<AdminUserSummary>(`admin/users/${id}/summary`)
    return data
}

export async function addAdminUserRole(id: string, role: ElevatedRole) {
    const { data } = await eventsAuthenticatedAxios.post<AdminUserRoleMutationResponse>(`admin/users/${id}/roles/add`, { role })
    return data
}

export async function removeAdminUserRole(id: string, role: ElevatedRole) {
    const { data } = await eventsAuthenticatedAxios.post<AdminUserRoleMutationResponse>(`admin/users/${id}/roles/remove`, { role })
    return data
}